
import Menubar from "../Menubar";
import { store } from "../../App";
// import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
// import { MdOutlinePictureAsPdf } from "react-icons/md";
// import { useEffect, useState } from "react";
import autoTable from "jspdf-autotable";
import {  Row, Col, Container, Button} from "react-bootstrap";
import  {allowAlphabetAndSpacesOnly } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import { Field, FormikProvider, Form, useFormik } from "formik";
import { FaRegSave } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
export default function DefaultUrl() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();

    let username = localStorage.getItem("username");
 
  const formik = useFormik({
    initialValues: {
        url: ""
     
    },

  })
 const Addurl =(url,type)=>{
  if(!url){
    showAlertMessage("Please enter URL","warning");
    return;
  }
  store.dispatch({ type: "SHOW_SPINNER" });
  let params={
    "type": type,
    "userId": username,
    "url": url
  }
    KpiService.defaulturl(params)
.then((res) => {
  if(res.data){
   showAlertMessage(res.data.SDESC,res.data.SCODE === "01"?"success":"warning",()=>{formik.resetForm();});
  }
 }).catch((error) => {
  formik.resetForm();
  console.error("Error in populationReport:", error); 
}).finally(()=>{store.dispatch({ type: "HIDE_SPINNER" })});
}
  return (
    <>
      <Menubar />
      <Container fluid  className='map-header1'  >
        <div className='sa-title'>
          <h2>Default URL<span> Service</span></h2>
        </div>
      </Container>

      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
        <Row className="mb-3 mt-3">
     <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} >
                                             <label className="mb-1 fw-bold">URL</label> <span style={{ color: "red" }}> *</span>
                                             <Field type="text" name="url" className="form-control" onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} onChange={(e) => { formik.handleChange(e); }} />
                                            
                                         </Col>
                                         
                                                                  <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
  <div className="bottom-buttons mt-4" style={{ display: "flex", gap: "8px" }}>
    <Button
      variant=""
      size="sm"
      className="save-btn"
      onClick={() => Addurl(formik.values.url, "add")}
    >
      Add Url <FaRegSave className="ms-1 s-icon" />
    </Button>

    <Button
      variant=""
      size="sm"
      className="danger-btn"
      onClick={() => Addurl(formik.values.url, "remove")}
    >
      Delete Url <MdDeleteOutline size={25} className="ms-1 s-icon" />
    </Button>
  </div>
</Col>


        </Row>


           </Form></FormikProvider>

<AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
      </Container >
    </>
  );
};



